module.exports = __webpack_public_path__ + "static/media/company.555b0987.svg";